/*! dependencies: cash, jquery-throttle-debounce, general */

instant.header = {
  settings: cash.extend({}, instant.settings && instant.settings.header ? instant.settings.header : {}),
  initialized: false,
  init: function () {
    if (!instant.header.initialized) {
      instant.header.initialized = true;

      var header = cash('header');

      if (header.length) {
        instant.header.initBurgerMenuButtonAttributes();
      }
    }
  },
  toggleBurgerMenu: function () {
    const hamburger = cash('#hamburger');
    const screenReaderText = hamburger.find('span');
    cash('header').toggleClass('burger-open');
    cash('body').toggleClass('overflow-y-hidden');

    const hamburgerExpandedValue = hamburger.attr('aria-expanded');

    if (hamburgerExpandedValue === 'false') {
      hamburger.attr('aria-expanded', 'true');
      screenReaderText.text('Menu (Åben)');
    } else {
      hamburger.attr('aria-expanded', 'false');
      screenReaderText.text('Menu (Lukket)');
    }
  },
  toggleBurgerMenuItem: function (elm) {
    var wrapper = cash(elm).closest('li');

    wrapper.toggleClass('active');
    wrapper.find('ul').toggleClass('hidden');
  },
  initBurgerMenuButtonAttributes: function () {
    const hamburger = cash('#hamburger');
    const screenReaderText = hamburger.find('span');
    hamburger.attr('aria-controls', 'hamburger-menu');
    hamburger.attr('aria-expanded', 'false');
    screenReaderText.text('Menu (Lukket)');
  },
  toggleOverlay: function (targetId) {
    var target = document.getElementById(targetId);

    if (target.classList.contains('hidden')) {
      //Overlay is hidden
      document.body.classList.add('overflow-y-hidden');
      target.classList.remove('hidden');
      setTimeout(() => {
        target.classList.add('opacity-100');
      }, 1);
      target.querySelector('input').focus();
    } else {
      //Overlay is shown
      target.classList.remove('opacity-100');
      setTimeout(() => {
        target.classList.add('hidden');
      }, 301);

      var isMobileNavOpen = document.getElementById('hamburger').getAttribute('aria-expanded') === 'true';
      if (!isMobileNavOpen) {
        document.body.classList.remove('overflow-y-hidden');
      }
      // const hamburger = cash('#hamburger');
      // const hamburgerExpandedValue = hamburger.attr('aria-expanded');
    }
  }
};